<template>
    <BasePopup>
        <div
            class="popupModal"
            v-bind:style="{
                zIndex: zIndexMapping[contentStyle.zIndex],
                textAlign: contentStyle.textAlign,
            }"
        >
            <div
                class="popupModal-content"
            >
                <I18nT v-bind:keypath="title" tag="h2" />
                <slot name="content" />
                <button
                    type="button"
                    class="button popupModal-btn"
                    v-bind:class="buttonGa"
                    v-on:click="closePopup"
                >
                    <I18nT v-bind:keypath="buttonText" />
                </button>
            </div>
        </div>
    </BasePopup>
</template>

<script lang="ts">
    import type { PropType } from 'vue';
    import { defineComponent } from 'vue';
    import BasePopup from '@/components/common/BasePopup.vue';
    import type { TextAlign, ZIndex } from '@/interface/enum';
    import { zIndexMapping } from '@/libraries/helpers/zIndexHelper';
    import { i18n } from '@/libraries/i18n';

    type PopupStyle = {
        zIndex: ZIndex;
        textAlign: TextAlign;
    }

    export default defineComponent({
        name: 'Popup',
        components: { BasePopup },
        emits: ['callback'],
        props: {
            buttonText: {
                type: String,
                required: true,
            },
            contentStyle: {
                type: Object as PropType<PopupStyle>,
                required: true,
            },
            buttonGa: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                required: true,
            },
        },
        setup(_, { emit }) {
            const closePopup = () => {
                emit('callback');
            };

            return {
                i18n,
                closePopup,
                zIndexMapping,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/popupModal";
</style>
